// extracted by mini-css-extract-plugin
export default {"question":"styles_question__arFmZ","title":"styles_title__3DT8a","desktop":"styles_desktop__W1GWp","answers":"styles_answers__HruPb"};